import { render, staticRenderFns } from "./sale.vue?vue&type=template&id=4196fa78&scoped=true&"
import script from "./sale.vue?vue&type=script&lang=js&"
export * from "./sale.vue?vue&type=script&lang=js&"
import style0 from "./sale.vue?vue&type=style&index=0&id=4196fa78&lang=scss&scoped=true&"
import style1 from "./sale.vue?vue&type=style&index=1&id=4196fa78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4196fa78",
  null
  
)

export default component.exports